/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Try_AgainInputs */

const en_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const es_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentar de nuevo`)
};

const de_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuchen Sie es erneut`)
};

const zh_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再试一次`)
};

const ar_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حاول مرة أخرى`)
};

const fr_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayer à nouveau`)
};

const vi_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

const sw_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaribu tena`)
};

const th_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองอีกครั้ง`)
};

const bs_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokušaj ponovo`)
};

const ja_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一度お試しください`)
};

const ko_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 시도`)
};

const pt_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente novamente`)
};

const it_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova di nuovo`)
};

const sv_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Försök igen`)
};

const nl_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probeer opnieuw`)
};

const da_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv igen`)
};

const nb_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv igjen`)
};

const fi_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritä uudelleen`)
};

const pl_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spróbuj jeszcze raz`)
};

const ru_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте еще раз`)
};

const tr_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar deneyin`)
};

const hi_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिर से कोशिश करो`)
};

const id_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba lagi`)
};

const ms_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba lagi`)
};

const cs_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkus to znovu.`)
};

const el_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προσπάθησε ξανά.`)
};

const he_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נסו שוב`)
};

const af_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probeer weer`)
};

const hu_error_try_again = /** @type {(inputs: Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próbáld újra.`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Error_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const error_try_again = /** @type {((inputs?: Error_Try_AgainInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Try_AgainInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_error_try_again(inputs)
	if (locale === "de") return de_error_try_again(inputs)
	if (locale === "zh") return zh_error_try_again(inputs)
	if (locale === "ar") return ar_error_try_again(inputs)
	if (locale === "fr") return fr_error_try_again(inputs)
	if (locale === "vi") return vi_error_try_again(inputs)
	if (locale === "sw") return sw_error_try_again(inputs)
	if (locale === "th") return th_error_try_again(inputs)
	if (locale === "bs") return bs_error_try_again(inputs)
	if (locale === "ja") return ja_error_try_again(inputs)
	if (locale === "ko") return ko_error_try_again(inputs)
	if (locale === "pt") return pt_error_try_again(inputs)
	if (locale === "it") return it_error_try_again(inputs)
	if (locale === "sv") return sv_error_try_again(inputs)
	if (locale === "nl") return nl_error_try_again(inputs)
	if (locale === "da") return da_error_try_again(inputs)
	if (locale === "nb") return nb_error_try_again(inputs)
	if (locale === "fi") return fi_error_try_again(inputs)
	if (locale === "pl") return pl_error_try_again(inputs)
	if (locale === "ru") return ru_error_try_again(inputs)
	if (locale === "tr") return tr_error_try_again(inputs)
	if (locale === "hi") return hi_error_try_again(inputs)
	if (locale === "id") return id_error_try_again(inputs)
	if (locale === "ms") return ms_error_try_again(inputs)
	if (locale === "cs") return cs_error_try_again(inputs)
	if (locale === "el") return el_error_try_again(inputs)
	if (locale === "he") return he_error_try_again(inputs)
	if (locale === "af") return af_error_try_again(inputs)
	if (locale === "hu") return hu_error_try_again(inputs)
	return en_error_try_again(inputs)
});